/// <amd-module name="Dashboards/Common/RefreshManager" />
import { Observable } from "VSS/Core/Observable";
import String = require("VSS/Core/Util/String");

import { PageVisibility } from "Dashboards/Common/PageVisibility";
import * as CommonResources from "Dashboards/Common/Resources";

export class DashboardRefreshManager extends Observable<null> {
    private static instance: DashboardRefreshManager;

    public static getInstance(): DashboardRefreshManager {
        if (!DashboardRefreshManager.instance) {
            DashboardRefreshManager.instance = new DashboardRefreshManager();
        }

        return DashboardRefreshManager.instance;
    }

    /* Time stamp on when the timer started */
    private startDateTime: Date;

    /* Handle for updating the 'Last Updated.. ' text */
    private updateTimerHandle: number | null;

    /* Whether the refresh counter would get trigger or not */
    private refreshCountdownEnable: boolean = true;
    /* Time in minutes for the refresh */
    public refreshTimeout: number = 0;

    /* Time stamp that refresh should happen */
    public refreshDateTime: Date;

    public getTimeLabelText(): string {
        const secondsPassed = this.getTimeDifferenceInSecond(this.startDateTime, new Date());
        if (secondsPassed != undefined) {
            const minutePassed = Math.floor(secondsPassed / 60);
            if (minutePassed == 0) {
                return CommonResources.Dashboard_Timer_Initialized;
            } else if (minutePassed == 1) {
                return CommonResources.Dashboard_Timer_Updated_one_minute;
            } else if (minutePassed >= 60) {
                // Stop updating the text if we get passed 1 hour
                return CommonResources.Dashboard_Timer_Updated_hours;
            } else if (minutePassed > 1) {
                return String.format(CommonResources.Dashboard_Timer_Updated_minutes, minutePassed);
            }
        }
        return "";
    }

    /**
     * Set the refresh time for the RefreshTimout, and start it right away. If the refresh time is invalid, stop the timer.
     * @refreshTime: the time in minute for the timer to expire
     */
    public setAndStartRefreshTimer(refreshTime: number) {
        this.refreshTimeout = refreshTime;
        if (this.refreshTimeout) {
            this.resetRefreshCountdown();
        } else {
            this.stop();
        }
    }

    /**
     * Reset the refresh countdown timer
     */
    public resetRefreshCountdown(): void {
        if (this.refreshTimeout) {
            this.stop();
            this.startDateTime = new Date();
            this.refreshDateTime = new Date(this.startDateTime.getTime() + this.refreshTimeout * 60 * 1000);
            this.refreshCountdownEnable = true;
            this.tick();
        }
    }

    /**
     * Stop timer to trigger the callback, label would still get updated
     */
    public stopRefreshCountdown() {
        this.refreshCountdownEnable = false;
    }

    private tick() {
        const now = new Date();
        const secondsToRefresh = this.getTimeDifferenceInSecond(now, this.refreshDateTime);
        if (secondsToRefresh && secondsToRefresh <= 0 && this.refreshCountdownEnable && PageVisibility.isPageVisible()) {
            this.stop();
            this.notify(null, "refresh_dashboards");
        } else {
            this.updateTimerHandle = setTimeout(() => {
                this.tick();
            }, 1000);
        }
    }

    private getTimeDifferenceInSecond(startTime: Date, endTime: Date): number | null {
        if (startTime && endTime) {
            return Math.floor((endTime.getTime() - startTime.getTime()) / 1000);
        } else {
            return null;
        }
    }

    private stop() {
        if (this.updateTimerHandle != null) {
            clearTimeout(this.updateTimerHandle);
            this.updateTimerHandle = null;
        }
    }
}
